import { Component, OnInit, Input, ViewChild, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { AppService } from '../../app.service';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../shared/base.component';
import { QuestionnairesService } from '../questionnaires/questionnaires.service';
import {finalize} from 'rxjs/operators';
import { PatientService } from '../patient.service';
import { FormBuilder, Validators } from '@angular/forms';
import { IMyDpOptions, IMyInputFieldChanged, IMyInputFocusBlur } from 'mydatepicker';
import * as moment from 'moment';
import { PatientsService } from '../../patients/patients.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-patient-questionnaires',
    templateUrl: './patient-questionnaires.component.html',
    styleUrls: ['./patient-questionnaires.component.scss']
})
export class PatientQuestionnairesComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {

    constructor(
        public appService: AppService,
        public authService: AuthService,
        public baseService: BaseService,
        public questionnairesService: QuestionnairesService,
        public patientService: PatientService,
        public fb: FormBuilder,
        public patientsService : PatientsService,
        public route: ActivatedRoute,
        public translate: TranslateService,
        public router: Router) {
            super(authService, router, baseService, appService);
    }

    @Input() items: Object[] = [];
    @Input() patient;
    @Input() role: number = 3;
    @Input() id: number;
    @Input() tabs: any;

    @Output() action = new EventEmitter();

    @ViewChild('tinymce', { static: false }) tinymce;
    formAction = 'open';
    selectedId = 0;
    questionnaireEmailTemplates: Object[] = [];
    emailReminderTemplates: Object[] = [];
    questionnaireType: string = 'se_di';
    isEmailQuestionnaire: boolean = false;
    isValidDueDate: boolean = true;
    completeWays = '';
    regexForQuestionnaireTag = /<a\s+(?:[^>]*?\s+)?title=['"]?questionnaire-link["'](.*?)\1/;
    questionnaires: Object[] = [];
    selectedTemplateTranslationId: number = 0;
    selectedTemplateReminderId: number = 0;
    btnSubmitText: string = 'Add';
    titleText: string = 'Open Questionnaire';
    dpkDueDateOptions: IMyDpOptions = {
        dateFormat: 'dd.mm.yyyy',
        showTodayBtn: false,
        componentDisabled: false,
        disableUntil: {
            year: null,
            month: null,
            day: null
        }
    };
    dateFormat = 'DD.MM.YYYY';
    public ANSWER_METHOD_TYPE = {
        LOCAL: 'local',
        EMAIL: 'email'
    };
    questionnaireChangeSub: Subscription;
    validateCssDueDate: string = 'form-unfocused';
    showArchiveMessageFuture = true;

    readonly patientProgressTableColumns = [
        ['sequence_text', 'Questionnaire', 'col-xs-4 col-sequence', 'text'],
        ['updated_at_diff', 'Update', 'col-xs-2 col-updated', 'text'],
        ['step_text', 'Status', 'col-xs-6 col-status', 'text'],
    ];

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            for (const param in params) {
                if (params.hasOwnProperty(param) && param !== 'page' && param !== 'items' && param !== 'filters') {
                    this.params[param] = params[param];
                }
            }
        });

        this.questionnaireChangeSub = this.appService.subscribe('updateQuestionnaireStatus', (data : any) => {
            let latestItem =  this.items[0];
            if (latestItem['archived'] && !latestItem['di_questionnaire']['archived']) {
                latestItem['progess_status_code'] = data.progess_status_code;
                latestItem['step_text'] = data.step_text;
            }
        });
    }

    ngOnDestroy() {
        if (this.questionnaireChangeSub) {
            this.questionnaireChangeSub.unsubscribe();
        }
    }

    ngAfterViewInit() {
        switch (this.params['action']) {
            case 'reminder': {
                this.openFormModal({
                    action: 'reminder',
                    title: 'Send Reminder',
                    id: this.params['id'],
                    url: 'patient/' + this.id,
                    email: this.params['email']
                });
                break;
            }
            case 'archive': {
                this.confirmAction({
                    url: 'patient/' + this.id,
                    action: 'archive',
                    id: this.params['id'],
                    title: 'Archive Self Evaluation',
                    content: 'Are you sure you want to archive the Self Evaluation?',
                    description: null
                });
                break;
            }
            default: {
                break;
            }
        }
    }

    setSelectedId(id) {
        this.selectedId = id;
    }

    getItem(referenceId: number) {
        for (let item of this.items) {
            if (item['id'] === +referenceId) {
                return item;
            }
        }
    }

    /**
     * When the user click on (play) button on questionnaire list
     * @param patientQuestionnaire
     * @param checkSE
     */
     beginInterview(patientQuestionnaire) {
        let questionnaireType = patientQuestionnaire.questionnaire.type;
        this.questionnairesService.openQuestionnaire(patientQuestionnaire.id, questionnaireType).subscribe();

        const SELink = patientQuestionnaire.is_repeated ? 'repeat-self-evaluation/' : 'self-evaluation/';
        const interviewLink = SELink + patientQuestionnaire.token;
        this.authService.logout();
        this.router.navigate([interviewLink]);
    }

    /**
     * Open send reminder or send questionnaire model
     *
     * @param {Object} params
     * @returns {any}
     */
    openFormModal(params: Object) {
        this.params = params;

        if (params['action'] === 'add') {
            this.formAction = 'open';
            return this.openQuestionnaireModal(params);
        }

        this.formAction = params['action'];

        return this.handleSendReminder(params);
    }

    /**
     * Open Add/Send questionnaire form
     * @param {Object} params
     */
     openQuestionnaireModal(params: Object) {
        if (!params['url'] || params['url'] === '') {
            params['url'] = window.location.pathname;
        }

        /**
         * Define form open questionnaire
         * @type {FormGroup}
         */
        this.form = this.fb.group({
            id: [{ value: null }],
            patient_id: [{ value: null }],
            questionnaire_type_id: [{ value: null }],
            token: [{ value: null }],
            answer_method: [{ value: null }],
            email: [{ value: null }],
            due_date: [{ value: null }],
            template_translation_id: [{ value: null }],
            content: [{ value: '' }, [<any>Validators.required, Validators.pattern(this.regexForQuestionnaireTag)]],
            email_subject: [{ value: '' }],
            email_header: [{ value: '' }],
            add_disclaimer: [{ value: false }],
            disclaimer_text: [{ value: '' }],
        });

        /**
         * Get user info and set default value
         */
        this.questionnairesService.read(this.id, params['questionnaireType']).pipe(
            finalize(() => this.isLoading = false))
            .subscribe(
                response => {
                    this.questionnaires = response['questionnaires'];

                    /**
                     * Parse email template by language
                     */
                    const languageId = this.patient.language_id;
                    let filteredByLanguages = [];
                    if (response['emailTemplates']) {
                        filteredByLanguages = response['emailTemplates']
                            .map(template => template.translations.filter(function (translation) {
                                return translation.language_id === languageId;
                            }));
                    }

                    this.questionnaireEmailTemplates = [].concat.apply([], filteredByLanguages);

                    if (this.role === 4) {
                        this.questionnaires = this.questionnaires.filter(element => element['type'] !== 'di');
                    }
                    this.form.controls['patient_id'].setValue(this.patient['id']);
                    this.form.controls['questionnaire_type_id'].setValue(params['questionnaireType']);
                    this.form.controls['email'].setValue(this.patient['email']);
                    this.form.controls['token'].setValue(this.patient['token']);
                    this.form.controls['template_translation_id'].setValue(0);
                    this.form.controls['answer_method'].setValidators([<any>Validators.required]);
                    this.form.controls['answer_method'].setValue(
                        params['answerMethod'] ? params['answerMethod'] : this.ANSWER_METHOD_TYPE.EMAIL
                    );
                    this.form.controls['answer_method'].enable();

                    this.initDueDateCalendarSettings();

                    this.showModal();

                    this.modal.onShown.subscribe(() => {
                        if (this.tinymce) {
                            this.onAnswerMethodChange(params['answerMethod'] ? params['answerMethod'] : this.ANSWER_METHOD_TYPE.EMAIL);
                        }
                    });

                    this.sub = this.form.get('answer_method').valueChanges.subscribe(data => {
                        if (data === 'send') {
                            this.formAction = 'send';
                        } else {
                            this.formAction = 'open';
                        }
                    });

                    const self = this;
                    this.sub = this.form.get('questionnaire_type_id').valueChanges.subscribe(data => {
                        this.formAction = 'open';

                        self.questionnaires.forEach(function (item) {
                            if (+data === item['type']) {
                                self.completeWays = item['answer_method'];
                            }
                        });

                        this.form.controls['answer_method'].setValue(null);
                    });
                },
                error => {
                    this.errorMessage = this.appService.parseErrors(error);
                    this.openAlertModal({ icon: 'fas fa-exclamation-triangle', warning: true }, this.errorMessage);
                }
            );
    }

    openAlertModal(params: Object, errorMessage: any) {
        const dialog = this.dialog.openAlert(params);
        dialog.onSubmit(() => {
            return;
        });

        dialog.showAlert(errorMessage[0]);
    }

    /**
     * Handle email/open local device method change
     * @param {string} answerQuestionnaireMethod
     */
     onAnswerMethodChange(answerQuestionnaireMethod: string) {
        if (answerQuestionnaireMethod == 'email') {
            this.isEmailQuestionnaire = true;

            this.form.controls['email'].enable();
            this.form.controls['due_date'].enable();

            this.form.controls['template_translation_id'].enable();
            this.form.controls['template_translation_id'].setValue(this.questionnaireEmailTemplates[0]['id']);

            this.form.controls['content'].enable();
            this.form.controls['content'].setValue(this.questionnaireEmailTemplates[0]['content']);
            this.form.controls['content'].setValidators([<any>Validators.required, Validators.pattern(this.regexForQuestionnaireTag)]);

            this.form.controls['email_subject'].setValue(this.questionnaireEmailTemplates[0]['email_subject']);
            this.form.controls['email_header'].setValue(this.questionnaireEmailTemplates[0]['email_header']);
            this.form.controls['add_disclaimer'].setValue(this.questionnaireEmailTemplates[0]['add_disclaimer']);
            this.form.controls['disclaimer_text'].setValue(this.questionnaireEmailTemplates[0]['disclaimer_text']);

            this.tinymce.editor.setMode('design');

            this.form.controls['email'].setValidators([
                <any>Validators.required,
                <any>Validators.pattern('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}')
            ]);

            this.form.controls['email'].setValue(this.patient['email']);
            this.form.controls['due_date'].setValidators([<any>Validators.required]);

            this.btnSubmitText = 'Send';
            this.titleText = 'Send Questionnaire';
        } else {
            this.isEmailQuestionnaire = false;
            this.btnSubmitText = 'Add';
            this.titleText = 'Open Questionnaire';

            this.disableEmailMethodControls();
            this.form.controls['content'].setValue('');
            this.tinymce.editor.setMode('readonly');
        }
    }

    disableEmailMethodControls() {
        this.form.controls['email'].disable();
        this.form.controls['due_date'].disable();
        this.form.controls['template_translation_id'].disable();

        this.form.controls['email'].clearValidators();
        this.form.controls['content'].clearValidators();
    }

    /**
     * Load data for send reminder window
     * @param {Object} params
     */
    handleSendReminder(params: Object) {
        this.initForm(params);

        this.form = this.fb.group({
            id: [{ value: null }],
            type: [{ value: null }],
            email: [{ value: null }],
            template_translation_id: 1,
            due_date: '',
            content: ['', [<any>Validators.required, <any>Validators.pattern(this.regexForQuestionnaireTag)]],
            email_subject: [{ value: '' }],
            email_header: [{ value: '' }],
            add_disclaimer: [{ value: false }],
            disclaimer_text: [{ value: '' }],
        });

        this.initDueDateCalendarSettings();

        this.patientsService.read(this.id).subscribe(response => {
            this.patient = response['patient'];

            this.form.controls['email'].setValue(this.patient['email']);
            this.form.controls['email'].setValidators([<any>Validators.required,
            <any>Validators.pattern('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}')]);

            /**
             * Parse email template by language
             */
            let languageId = this.patient.language_id;
            this.initTemplate(response['templates'], languageId);
            
            this.showModal();
        },
            error => {
                this.errorMessage = this.appService.parseErrors(error);
            }
        );
    }

    initTemplate(templates, languageId) {
        let filteredByLanguages = templates.map(template => template.translations.filter(function (translation) {
            return translation.language_id == languageId;
        }));
        this.emailReminderTemplates = [].concat.apply([], filteredByLanguages);

        /**
         * Define reminder form
         */
        this.form.controls['content'].setValidators([<any>Validators.required, Validators.pattern(this.regexForQuestionnaireTag)]);
        this.form.controls['content'].setValue(this.emailReminderTemplates[0]['content']);

        this.form.controls['email_subject'].setValue(this.emailReminderTemplates[0]['email_subject']);
        this.form.controls['email_header'].setValue(this.emailReminderTemplates[0]['email_header']);
        this.form.controls['add_disclaimer'].setValue(this.emailReminderTemplates[0]['add_disclaimer']);
        this.form.controls['disclaimer_text'].setValue(this.emailReminderTemplates[0]['disclaimer_text']);

        this.form.controls['template_translation_id'].setValue(this.emailReminderTemplates[0]['id']);
        this.selectedTemplateReminderId = this.emailReminderTemplates[0]['id'];
    }

    /**
     * Handle on drop down change
     * @param templateTranslationId
     */
    onSelectReminderTemplate() {
        let selectedTemplate = this.emailReminderTemplates.find((template) => {
            return template['id'] == this.selectedTemplateReminderId;
        });

        this.form.controls['content'].markAsPristine();
        this.form.controls['content'].setValue(selectedTemplate['content']);

        this.form.controls['email_subject'].setValue(selectedTemplate['email_subject']);
        this.form.controls['email_header'].setValue(selectedTemplate['email_header']);
        this.form.controls['add_disclaimer'].setValue(selectedTemplate['add_disclaimer']);
        this.form.controls['disclaimer_text'].setValue(selectedTemplate['disclaimer_text']);
    }

    onRevertTemplateReminder() {
        let selectedTemplate = this.emailReminderTemplates.find((template) => {
            return template['id'] == this.selectedTemplateReminderId;
        });

        if (!selectedTemplate) {
            selectedTemplate = this.emailReminderTemplates[0];
        }

        this.form.controls['content'].markAsPristine();
        this.form.controls['content'].setValue(selectedTemplate['content']);
    }

    /**
     * Set default value for due date
     */
    initDueDateCalendarSettings(): void {
        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);

        this.dpkDueDateOptions.disableUntil.year = +yesterday.getFullYear();
        this.dpkDueDateOptions.disableUntil.month = +yesterday.getMonth() + 1;
        this.dpkDueDateOptions.disableUntil.day = +yesterday.getDate();

        let next5Days = moment().add(5, 'days');
        this.form.patchValue({
            due_date: {
                date: {
                    year: next5Days.format('Y'),
                    month: next5Days.format('M'),
                    day: next5Days.format('D'),
                }
            }
        });
    }

    confirmToArchive(item) {
        this.formAction = null;
        this.responseMessage = '';
        this.confirmAction({
            url: 'patient/' + this.id,
            action: 'archive',
            id: item.id,
            title: 'Archive Questionnaire',
            content: 'Are you sure you want to archive this questionnaire?',
            description: null
        });
    }

    confirmToDelete(item) {
        this.formAction = null;
        this.confirmAction({
            url: 'patient/' + this.id,
            action: 'delete',
            id: item.id,
            title: 'Delete Questionnaire',
            content: 'Are you sure you want to delete this questionnaire?',
            description: null
        });
    }

    confirmAction(params: Object) {
        this.initForm(params);
        this.showModal();
    }

    archiveQuestionnaires(id) {
        this.isLoading = true;
        const showInFuture = this.showArchiveMessageFuture ? 1 : 0;
        this.questionnairesService.archiveQuestionnaires(id, showInFuture).pipe(
            finalize(() => this.isLoading = false))
            .subscribe(
                response => {
                    let message = response['message'];
                    this.isUpdated = true;
                    this.authService.setData('show_confirm_archive_self_report_modal', showInFuture);

                    // disable the selected diagnosis additions/removals
                    this.patientService.questionnaireIsArchived = true;

                    if (message !== 'undefined' && message !== '') {
                        this.responseMessage = message;
                        return;
                    }

                },
                error => {
                    this.isLoading = false;
                    this.errorMessage = this.appService.parseErrors(error);
                }
            );
    }

    deleteQuestionnaires(id) {
        this.isLoading = true;
        this.questionnairesService.deleteQuestionnaires(id).pipe(
            finalize(() => this.isLoading = false))
            .subscribe(
                response => {
                    let message = response['message'];
                    this.isUpdated = true;

                    // stop highlighting the diagnoses toggle & diagnosis addition buttons after resetting the DI questionnaires
                    this.appService.publish('patient', { questionnaireIsReset: true });

                    if (message !== 'undefined' && message !== '') {
                        this.responseMessage = message;
                        return;
                    }
                },
                error => {
                    this.isLoading = false;
                    this.errorMessage = this.appService.parseErrors(error);
                }
            );
    }

    doAction(questionnaire) {

        if(this.authService.isAssistant || (this.authService.isAssistantPlus && this.patient['has_permission'] !== this.patientService.ACCESSSTATUS['GRANTED'])) {
            return;
        }

        if(questionnaire.step >= 4 && questionnaire.di_questionnaire.step === 0) {
            return this.action.emit({ action : this.tabs.SR, questionnaire : questionnaire});
        }

        if(questionnaire.archived && questionnaire.di_questionnaire.step === 3) {
            return this.action.emit({ action : this.tabs.CV, questionnaire : questionnaire})
        }

        if(questionnaire.archived && questionnaire.di_questionnaire.step > 3) {
            return this.action.emit({ action : this.tabs.PROPOSALS, questionnaire : questionnaire})
        }
    }

    sendReminder(model: any, isValid: boolean, url?: string) {
        this.formSubmitted = true;
        if (!isValid) {
            return;
        }

        this.isLoading = true;
        if (model.due_date instanceof Object) {
            let formattedDueDate = moment({
                day: model.due_date.date.day,
                year: model.due_date.date.year,
                month: model.due_date.date.month - 1, // http://momentjs.com/docs/#/get-set/month/
            });

            model["due_date"] = formattedDueDate.format(this.dateFormat);
        }

        let questionnaireId = this.params['id'];

        this.questionnairesService.sendReminder(
            this.id,
            questionnaireId,
            model.email,
            model.content,
            model.due_date ? model.due_date : this.form.controls.due_date.value,
            model.template_translation_id,
            model.add_disclaimer,
            model.disclaimer_text,
            model.email_subject,
            model.email_header
        ).pipe(finalize(() => {
            this.isLoading = false;
        })).subscribe(
            response => {
                this.hideModal();
            },
            error => {
                this.isLoading = false;
                this.errorMessage = this.appService.parseErrors(error);
            }
        );
    }

    onDueDateInputChanged(event: IMyInputFieldChanged) {
        this.isValidDueDate = event.valid;
    }

    /**
     * Handle focus in and focus out input
     * @param {IMyInputFocusBlur} event
     */
     onDueDateFocusBlur(event: IMyInputFocusBlur): void {
        if (event.reason == 2 && !this.isValidDueDate) {
            this.validateCssDueDate = 'form-errored';
        } else if (event.reason == 2) {
            this.validateCssDueDate = 'form-unfocused';
        } else {
            this.validateCssDueDate = 'form-focused mat-focused';
        }
    }
}
